import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import API, { fmt } from '../utils/api';
import ProductPicker from '../components/ProductPicker';
import Pagination from '../components/Pagination';

export default function Inventory() {
  const { user } = useAuth();
  const [movements, setMovements]       = useState([]);
  const [modal, setModal]               = useState(false);
  const [suppliersList, setSuppliersList] = useState([]);
  const [type, setType]                 = useState('IN');
  const [items, setItems]               = useState([{ product_id:'', quantity:1 }]);
  const [meta, setMeta]                 = useState({ supplier_requestor:'', invoice_number:'', notes:'' });
  const [tab, setTab]                   = useState('movements');
  const [delConfirm, setDelConfirm]     = useState(null);
  const [supplierSearch, setSupplierSearch] = useState('');
  const [suppliers, setSuppliers]       = useState([]);
  const [suppFrom, setSuppFrom]         = useState('');
  const [suppTo, setSuppTo]             = useState('');
  const [search, setSearch]             = useState('');
  const [page, setPage]                 = useState(1);
  const PER_PAGE = 50;
  const [finishedProducts, setFinishedProducts] = useState([]);
  const [fpBrandFilter, setFpBrandFilter] = useState('');

  const isManager = ['admin','sales_manager','warehouse'].includes(user?.role);
  const isAdmin   = user?.role === 'admin';

  const load = () => API.get('/inventory/movements').then(r => setMovements(r.data));
  const loadSuppliers = (from, to) => {
    const p = new URLSearchParams();
    if (from) p.set('from', from);
    if (to)   p.set('to', to);
    API.get('/inventory/suppliers-summary?' + p).then(r => setSuppliers(r.data)).catch(() => {});
  };
  useEffect(() => {
    load();
    API.get('/suppliers').then(r => setSuppliersList(r.data)).catch(() => {});
  }, []);
  useEffect(() => { setPage(1); }, [tab, search]);
  useEffect(() => { if (tab === 'suppliers') loadSuppliers(suppFrom, suppTo); }, [tab]);
  useEffect(() => {
    if (tab === 'finished') {
      API.get('/finished-products').then(r => setFinishedProducts(r.data)).catch(() => {});
    }
  }, [tab]);

  const addItem    = () => setItems(i => [...i, { product_id:'', quantity:1 }]);
  const removeItem = (i) => setItems(arr => arr.filter((_,idx) => idx !== i));
  const updateItem = (i, f, v) => setItems(arr => arr.map((item,idx) => idx===i ? {...item,[f]:v} : item));

  const save = async () => {
    try {
      await API.post('/inventory/movement', { ...meta, movement_type: type, items });
      setModal(false);
      setItems([{ product_id:'', quantity:1 }]);
      setMeta({ supplier_requestor:'', invoice_number:'', notes:'' });
      API.get('/suppliers').then(r => setSuppliersList(r.data)).catch(() => {});
      load();
    } catch(e) { alert(e.response?.data?.error || 'حدث خطأ'); }
  };

  const deleteMovement = async (id) => {
    try {
      await API.delete('/inventory/movements/' + id);
      setDelConfirm(null); load();
    } catch(e) { alert(e.response?.data?.error || 'حدث خطأ'); }
  };

  const inMovements  = movements.filter(m => m.movement_type === 'IN');
  const outMovements = movements.filter(m => m.movement_type === 'OUT');
  const baseList     = tab==='movements' ? movements : tab==='in' ? inMovements : outMovements;
  const shown        = baseList.filter(m =>
    (!search || (m.product_name||'').includes(search) || (m.supplier_requestor||'').includes(search)) &&
    (tab==='suppliers' || !supplierSearch || (m.supplier_requestor||'').includes(supplierSearch))
  );
  const shownPaged   = shown.slice((page-1)*PER_PAGE, page*PER_PAGE);

  // Stats
  const totalIn  = inMovements.reduce((s,m) => s + m.quantity, 0);
  const totalOut = outMovements.reduce((s,m) => s + m.quantity, 0);

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">سجل المخزون</h1>
          <div className="page-title-sub">{movements.length} حركة مسجّلة</div>
        </div>
        {isManager && (
          <button className="btn btn-primary" onClick={() => setModal(true)}>
            + حركة مخزون
          </button>
        )}
      </div>



      {/* Tabs */}
      <div className="tabs" style={{ marginBottom:16 }}>
        {[['movements','كل الحركات'],['in','📥 الواردات'],['out','📤 الصادرات'],['finished','📦 المنتجات الجاهزة'],['suppliers','🏭 الموردون']].map(([v,l]) => (
          <button key={v} className={`tab ${tab===v?'active':''}`} onClick={() => setTab(v)}>{l}</button>
        ))}
      </div>

      {/* New Movement Modal */}
      {modal && (
        <div className="modal-overlay" onClick={() => setModal(false)}>
          <div className="modal" style={{ maxWidth:600 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">حركة مخزون جديدة</span>
              <button className="modal-close" onClick={() => setModal(false)}>✕</button>
            </div>
            <div className="modal-body">

              {/* Type Toggle */}
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:18 }}>
                {[
                  { v:'IN',  label:'📥 وارد',  color:'var(--success)', bg:'var(--success-bg)' },
                  { v:'OUT', label:'📤 صادر', color:'var(--danger)',  bg:'var(--danger-bg)' },
                ].map(opt => (
                  <button key={opt.v} type="button"
                    onClick={() => setType(opt.v)}
                    style={{
                      padding:'12px', borderRadius:10, border:'2px solid',
                      borderColor: type===opt.v ? opt.color : 'var(--border)',
                      background:  type===opt.v ? opt.bg   : 'var(--surface)',
                      color:       type===opt.v ? opt.color : 'var(--muted)',
                      fontWeight: 700, fontSize:'0.9rem', cursor:'pointer', transition:'all 0.15s'
                    }}>
                    {opt.label}
                  </button>
                ))}
              </div>

              <div className="form-grid" style={{ marginBottom:16 }}>
                <div className="form-group">
                  <label>{type==='IN' ? <span>المورد <span style={{color:'var(--danger)'}}>*</span></span> : 'الطالب'}</label>
                  {type==='IN' ? (
                    <select value={meta.supplier_requestor} onChange={e => setMeta({ ...meta, supplier_requestor: e.target.value })}
                      style={{ border: !meta.supplier_requestor ? '1.5px solid var(--danger)' : undefined }}>
                      <option value="">-- اختر المورد --</option>
                      {suppliersList.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
                    </select>
                  ) : (
                    <input value={meta.supplier_requestor}
                      onChange={e => setMeta({ ...meta, supplier_requestor: e.target.value })}
                      placeholder="اسم الطالب..." />
                  )}
                </div>
                <div className="form-group">
                  <label>رقم الفاتورة</label>
                  <input value={meta.invoice_number}
                    onChange={e => setMeta({ ...meta, invoice_number: e.target.value })}
                    placeholder="INV-..." />
                </div>
                <div className="form-group span-2">
                  <label>ملاحظات</label>
                  <input value={meta.notes}
                    onChange={e => setMeta({ ...meta, notes: e.target.value })} />
                </div>
              </div>

              {/* Items */}
              <div style={{ borderTop:'1px solid var(--border-2)', paddingTop:14 }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
                  <span style={{ fontSize:'0.82rem', fontWeight:700, color:'var(--muted)', textTransform:'uppercase', letterSpacing:'0.5px' }}>
                    المواد ({items.length})
                  </span>
                  <button className="btn btn-sm btn-outline" onClick={addItem}>+ إضافة مادة</button>
                </div>

                {items.map((item, i) => (
                  <div key={i} className="inv-item-row" style={{ marginBottom:10 }}>
                    <div className="form-group inv-item-product" style={{ margin:0 }}>
                      {i===0 && <label style={{ fontSize:'0.78rem' }}>المادة</label>}
                      <ProductPicker
                        value={item.product_id}
                        onChange={p => { if(p) updateItem(i, 'product_id', p.id); }}
                        placeholder="اختر المادة..." />
                    </div>
                    <div className="inv-item-qty-row">
                      <div className="form-group" style={{ margin:0, flex:1 }}>
                        {i===0 && <label style={{ fontSize:'0.78rem' }}>الكمية</label>}
                        <input type="number" value={item.quantity} min={1}
                          onChange={e => updateItem(i, 'quantity', +e.target.value)}
                          style={{ textAlign:'center', fontSize:'1rem', fontWeight:700 }} />
                      </div>
                      <button className="btn btn-danger btn-icon"
                        style={{ marginTop: i===0 ? 22 : 0, flexShrink:0, height:42, width:42 }}
                        onClick={() => removeItem(i)} disabled={items.length===1}>✕</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={save}>💾 حفظ الحركة</button>
              <button className="btn btn-ghost" onClick={() => setModal(false)}>إلغاء</button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirm */}
      {delConfirm && (
        <div className="modal-overlay" onClick={() => setDelConfirm(null)}>
          <div className="modal" style={{ maxWidth:380 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">تأكيد الحذف</span>
              <button className="modal-close" onClick={() => setDelConfirm(null)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="alert alert-warning">سيتم عكس تأثير هذه الحركة على المخزون. هذا الإجراء لا يمكن التراجع عنه.</div>
              <div style={{ background:'var(--surface-2)', borderRadius:8, padding:'10px 14px', fontSize:'0.84rem', color:'var(--ink-2)', border:'1px solid var(--border-2)' }}>
                <div><strong>{delConfirm.order_number}</strong></div>
                <div className="text-muted">{delConfirm.product_name} — {delConfirm.quantity} {delConfirm.unit}</div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-danger" onClick={() => deleteMovement(delConfirm.id)}>🗑 حذف نهائي</button>
              <button className="btn btn-ghost" onClick={() => setDelConfirm(null)}>إلغاء</button>
            </div>
          </div>
        </div>
      )}

      {/* Finished Products Tab */}
      {tab === 'finished' && (() => {
        const fpBrands = [...new Set(finishedProducts.map(p => p.brand).filter(Boolean))].sort();
        const filtered = finishedProducts.filter(p => !fpBrandFilter || p.brand === fpBrandFilter);
        const totalStock = filtered.reduce((s, p) => s + (p.stock_qty || 0), 0);
        return (
          <div>
            {/* فلتر الماركة */}
            <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:14, alignItems:'center' }}>
              <span style={{ fontSize:'0.8rem', color:'var(--muted)', marginLeft:4 }}>الماركة:</span>
              <span onClick={() => setFpBrandFilter('')}
                style={{ padding:'3px 12px', borderRadius:20, fontSize:'0.75rem', cursor:'pointer', fontWeight:700,
                  background: fpBrandFilter==='' ? 'var(--primary)' : 'var(--surface)',
                  color: fpBrandFilter==='' ? 'white' : 'var(--text)', border:'1px solid var(--border)' }}>
                الكل
              </span>
              {fpBrands.map(b => (
                <span key={b} onClick={() => setFpBrandFilter(b)}
                  style={{ padding:'3px 12px', borderRadius:20, fontSize:'0.75rem', cursor:'pointer', fontWeight:700,
                    background: fpBrandFilter===b ? 'var(--primary)' : 'var(--surface)',
                    color: fpBrandFilter===b ? 'white' : 'var(--text)', border:'1px solid var(--border)' }}>
                  {b}
                </span>
              ))}
              <span className="text-muted" style={{ fontSize:'0.8rem', marginRight:'auto' }}>
                إجمالي المخزون الجاهز: <strong>{totalStock.toLocaleString()}</strong> قطعة
              </span>
            </div>
            <div className="table-container">
              <div className="table-scroll">
                <table>
                  <thead>
                    <tr>
                      <th>الماركة</th>
                      <th>النوع</th>
                      <th>المنتج</th>
                      <th>المخزون الجاهز</th>
                      <th>السعر</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtered.map(p => (
                      <tr key={p.id}>
                        <td>
                          <span style={{ background:'#6d28d9', color:'#ffffff', borderRadius:'20px', padding:'2px 10px', fontSize:'0.75rem', fontWeight:700, display:'inline-block' }}>{p.brand || '—'}</span>
                        </td>
                        <td className="text-muted" style={{ fontSize:'0.85rem' }}>{p.product_type || '—'}</td>
                        <td className="font-bold">{p.name}</td>
                        <td>
                          <span className={`badge ${(p.stock_qty||0) > 0 ? 'badge-success' : 'badge-gray'}`}>
                            {(p.stock_qty||0).toLocaleString()} قطعة
                          </span>
                        </td>
                        <td className="text-muted">{p.price > 0 ? `$ ${p.price}` : '—'}</td>
                      </tr>
                    ))}
                    {filtered.length === 0 && (
                      <tr><td colSpan={5} className="text-center text-muted" style={{ padding:32 }}>لا توجد منتجات</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
      })()}

      {/* Suppliers Tab */}
      {tab === 'suppliers' ? (
        <div>
          <div style={{ display:'flex', gap:10, marginBottom:16, flexWrap:'wrap', alignItems:'flex-end' }}>
            <div className="form-group" style={{ margin:0 }}>
              <label style={{ fontSize:'0.75rem' }}>من تاريخ</label>
              <input type="date" value={suppFrom} onChange={e => setSuppFrom(e.target.value)} />
            </div>
            <div className="form-group" style={{ margin:0 }}>
              <label style={{ fontSize:'0.75rem' }}>إلى تاريخ</label>
              <input type="date" value={suppTo} onChange={e => setSuppTo(e.target.value)} />
            </div>
            <button className="btn btn-secondary" onClick={() => loadSuppliers(suppFrom, suppTo)}>بحث</button>
            <button className="btn btn-ghost btn-sm" onClick={() => { setSuppFrom(''); setSuppTo(''); loadSuppliers('',''); }}>مسح</button>
            <span className="text-muted" style={{ fontSize:'0.8rem', alignSelf:'center' }}>{suppliers.length} مورد</span>
          </div>
          <div className="table-container">
            <div className="table-scroll">
              <table>
                <thead>
                  <tr>
                    <th>المورد</th><th>التوريدات</th><th>المواد</th>
                    <th>إجمالي الكمية</th><th>أول توريد</th><th>آخر توريد</th>
                  </tr>
                </thead>
                <tbody>
                  {suppliers.map(s => (
                    <tr key={s.supplier}>
                      <td className="font-bold">🏭 {s.supplier}</td>
                      <td><span className="badge badge-info">{s.movements_count} حركة</span></td>
                      <td><span className="badge badge-primary">{s.products_count} مادة</span></td>
                      <td className="font-bold text-success">{(s.total_qty||0).toLocaleString()}</td>
                      <td className="text-muted" style={{ fontSize:'0.8rem' }}>{s.first_date ? fmt.date(s.first_date) : '-'}</td>
                      <td className="text-muted" style={{ fontSize:'0.8rem' }}>{s.last_date ? fmt.date(s.last_date) : '-'}</td>
                    </tr>
                  ))}
                  {suppliers.length === 0 && (
                    <tr><td colSpan={6}><div className="empty-state"><div className="empty-state-icon">🏭</div><p>لا توجد بيانات موردين</p></div></td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : tab !== 'finished' ? (
        <>
          {/* Search */}
          <div style={{ marginBottom:12 }}>
            <input className="search-input" style={{ maxWidth:340 }}
              placeholder="🔍 بحث بالمنتج أو المورد..."
              value={search} onChange={e => setSearch(e.target.value)} />
          </div>

          <div className="table-container">
            <div className="table-scroll">
              <table>
                <thead>
                  <tr>
                    <th>النوع</th><th>المنتج</th><th>الكمية</th>
                    <th>المورد / الطالب</th><th>الموظف</th><th>التاريخ</th>
                    {isAdmin && <th></th>}
                  </tr>
                </thead>
                <tbody>
                  {shownPaged.map(m => (
                    <tr key={m.id}>
                      <td>
                        <span className={`badge ${m.movement_type==='IN' ? 'badge-success' : 'badge-danger'}`}>
                          {m.movement_type==='IN' ? '📥 وارد' : '📤 صادر'}
                        </span>
                      </td>
                      <td>
                        <div className="font-bold" style={{ fontSize:'0.875rem' }}>{m.product_name}</div>
                        {(m.category_name||m.brand||m.size) && (
                          <div className="text-muted" style={{ fontSize:'0.76rem' }}>{[m.category_name, m.brand, m.size].filter(Boolean).join(' · ')}</div>
                        )}
                      </td>
                      <td>
                        <span style={{
                          fontWeight:800, fontSize:'0.95rem',
                          color: m.movement_type==='IN' ? 'var(--success)' : 'var(--danger)'
                        }}>
                          {m.movement_type==='IN' ? '+' : '-'}{m.quantity} {m.unit}
                        </span>
                      </td>
                      <td className="text-muted" style={{ fontSize:'0.84rem' }}>{m.supplier_requestor || '-'}</td>
                      <td className="text-muted" style={{ fontSize:'0.84rem' }}>{m.employee_name || '-'}</td>
                      <td className="text-muted" style={{ fontSize:'0.8rem' }}>{fmt.datetime(m.created_at)}</td>
                      {isAdmin && (
                        <td>
                          <button className="btn btn-sm btn-danger btn-icon" onClick={() => setDelConfirm(m)}>🗑</button>
                        </td>
                      )}
                    </tr>
                  ))}
                  {shown.length === 0 && (
                    <tr><td colSpan={isAdmin?7:6}>
                      <div className="empty-state">
                        <div className="empty-state-icon">📦</div>
                        <p>{search ? 'لا توجد نتائج للبحث' : 'لا توجد حركات مخزون'}</p>
                      </div>
                    </td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          {shown.length > PER_PAGE && (
            <div style={{ marginTop:16 }}>
              <Pagination page={page} total={shown.length} perPage={PER_PAGE} onPage={setPage} />
            </div>
          )}
        </>
      ) : null}
    </div>
  );
}
